import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyTaskInformation = lazyWithRetry(() => import("./TaskInformation"));

const TaskInformation = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyTaskInformation taskId={""} {...props} />;

export default TaskInformation;
